import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import '../api/components-examples/Admin/admin.css'
import Signup from '../api/components-examples/UserSignup/index'
import WaitingLoaders from '../UI-components/Loaders/WaitingLoaders'

export const PublicRoutes = props => {
  return (
    <Switch>
      <Route
        exact
        path="/signup"
        key={'/signup'}
        render={props => (
          <Suspense fallback={<WaitingLoaders show={true} size={90} position='fixed' />}>
            {' '}
            <Signup {...props} />{' '}
          </Suspense>
        )}
      />
    </Switch>
  )
}
